<template>
  <section
    class="grid grid-rows-[auto_1fr] h-320 p-16 pt-12 rounded-lg bg-float-default-low"
    data-test="finder-card"
  >
    <header class="flex h-24 items-center gap-8 mb-12">
      <h3 class="body-1 body-1-bold grow">{{ title }}</h3>
      <RevTooltip v-if="tooltip" position="top">
        <template #trigger="{ show, hide }">
          <RevButtonBase
            :aria-label="tooltip"
            class="flex h-40 w-40 shrink-0 items-center justify-center rounded-full motion-safe:transition motion-safe:duration-[225ms] hover:bg-surface-default-mid active:bg-surface-default-low focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-default-hi"
            @focusin="show"
            @focusout="hide"
            @mouseleave="hide"
            @mouseover="show"
          >
            <IconQuestionMarkInCircle
              class="text-static-default-low"
              size="24"
            />
          </RevButtonBase>
        </template>
        {{ tooltip }}
      </RevTooltip>
    </header>

    <slot />
  </section>
</template>

<script lang="ts" setup>
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevTooltip } from '@ds/components/Tooltip'
import { IconQuestionMarkInCircle } from '@ds/icons/IconQuestionMarkInCircle'

defineProps<{
  title: string
  tooltip?: string
}>()
</script>
